import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import IconComponent from '../../atoms/Icon'
import ScoreComponent from '../../atoms/Score'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 2rem;
  @media ${mq(sizes.tablet)} {
    padding: 0 5rem;
  }
  @media ${mq(sizes.tablet)} {
    flex-flow: row wrap;
    gap: 2rem;
    justify-content: space-between;
    align-items: center;
  }
  @media print {
    padding: 0;
  }
`
export const Pictos = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-direction: column;
  @media ${mq(sizes.tablet)} {
    flex-direction: row;
    justify-content: center;
    gap: 2rem;
  }
  @media ${mq(sizes.desktop)} {
    justify-content: flex-start;
    gap: 4rem;
  }
  @media print {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0;
    margin: 0;
  }
`

export const Positive = styled(IconComponent)`
  height: 5rem;
  flex-shrink: 0;
`

export const Grid = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  & > * {
    width: 50%;
    height: 100%;
    align-items: center;
    border-top: 1px solid ${({ theme }) => theme.colors.gainsboro};
    padding: 1.5rem 2rem;
    justify-content: center;
    display: flex;
    position: relative;

    &:nth-child(2n):after {
      content: '';
      position: absolute;
      left: 0;
      top: 1.5rem;
      bottom: 1.5rem;
      border-right: 1px solid ${({ theme }) => theme.colors.gainsboro};
    }
  }
  @media ${mq(sizes.tablet)} {
    flex-wrap: nowrap;
    gap: 2rem;
    align-items: center;
    & > * {
      align-items: center;
      border: none;
      width: auto;
      padding: 0;
      &:nth-child(2n):after {
        content: none;
      }
    }
  }
  @media ${mq(sizes.desktop)} {
    gap: 4rem;
    & > * {
      height: auto;
    }
  }

  @media print {
    & > * {
      width: auto;
      height: 100%;
      align-items: center;
      border-top: 0;
      padding: 0 2rem;
      justify-content: center;
      display: flex;
      position: relative;
      &:nth-child(2n):after {
        content: '';
        border-right: 0;
      }
    }
  }
`

export const Score = styled(ScoreComponent)`
  display: flex;
  height: initial;
  flex-shrink: 0;
  justify-content: center;
  & > * {
    height: 5.3rem;
  }
`

export const IconItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem 1.5rem;
  @media ${mq(sizes.desktop)} {
    flex-direction: row;
  }
`
export const Icon = styled(IconComponent)`
  color: ${({ theme }) => theme.colors.ruby};
  width: 3.2rem;
  height: 3.2rem;
  flex-shrink: 0;
`
export const IconItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${mq(sizes.desktop)} {
    align-items: flex-start;
  }
`
export const IconItemLabel = styled.div`
  ${({ theme }) => theme.textStyles.textXXSmallCaps};
  color: ${({ theme }) => theme.colors.arapawa};
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH7};
  }
`
export const IconItemValue = styled.div`
  ${({ theme }) => theme.textStyles.textSmallStrong};
  color: ${({ theme }) => theme.colors.bismark};
  text-align: center;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.textLarge};
    text-align: initial;
  }
`
export const Date = styled.time`
  ${({ theme }) => theme.textStyles.textXSmallStrong}
  align-self: center;
  color: ${({ theme }) => theme.colors.grey};
`
